import { type HTMLAttributes } from 'react';
import { cn } from './cn';

export interface RequiredMarkProps extends HTMLAttributes<HTMLSpanElement> {
  /**
   * 시각적 필수 마커 문자. ID56 규칙상 빨강 `*` 로 통일.
   * (요구사항: 라벨 옆 `(필수)` 또는 `(*)` — 본 백오피스는 기존 표준인 `*` 채택)
   */
  symbol?: string;
}

/**
 * 필수 입력/선택 필드 마커 — 시스템 전반 단일 출처(SSoT).
 *
 * ID56 "전 화면 필수 입력/선택 필드 표기 통일": 라벨 우측에 빨강 `*`(--signal-danger)를
 * 일관되게 노출한다. 글자 자체는 보조기술에 무의미하므로 `aria-hidden` 처리하고,
 * 스크린리더에는 sr-only "필수" 텍스트로 의미를 전달한다.
 *
 * 공통 라벨 컴포넌트(FormRow / FormLabel / Label / FormSection)의 `required` prop 이
 * 이 컴포넌트를 렌더한다. 인라인 `<span>*</span>` 복붙을 대체한다.
 */
export const RequiredMark = ({ symbol = '*', className, ...props }: RequiredMarkProps) => (
  <span className={cn('ml-1 inline-flex items-baseline', className)} {...props}>
    {/* R4 SSoT: 굵기 700 명시(SF RequiredMark 와 시각 동형). 색=의미 토큰 --signal-danger. */}
    <span aria-hidden="true" style={{ color: 'var(--signal-danger)', fontWeight: 700 }}>
      {symbol}
    </span>
    <span className="sr-only">필수</span>
  </span>
);
RequiredMark.displayName = 'RequiredMark';
